// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"mak-model-year_breadcrumb__Xx7Lz","back_button":"mak-model-year_back_button__3TB2a","disable_breadcrumb":"mak-model-year_disable_breadcrumb__0_4J8"};